import { Navigate } from 'react-router';
import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';
import { companyTabPath } from '../company-settings.paths';
import { companyTabsFor } from '../policies/company-tabs';

/** `/company` opens the first tab this user may see; with none, there is nothing here for them. */
export function CompanyTabRedirect() {
  const { state } = useCurrentUser();
  const [first] = companyTabsFor(state.status === 'authenticated' ? state.user.permissions : []);
  return <Navigate to={first ? companyTabPath(first) : '/'} replace />;
}
